export class Capacity {
    productActivityId!: string
    capacityTypeId!: string
    capacity!: number
  }